<template>
  <div
    class="service-pack d-flex flex-column align-items-center"
    style="width: 8rem; border-radius: 1rem"
    :style="`border: 1px solid ${
      element.serviceType === 1
        ? 'rgba(118, 185, 0, 0.75)'
        : 'rgba(0, 113, 197, 0.75)'
    }; height: ${true ? '6.25rem' : '7.5rem'}`"
  >
    <div
      class="d-flex justify-content-center p-2"
      style="font-size: 0.8rem; width: 8rem; border-radius: 1rem 1rem 0 0"
      :style="`background-color: ${
        element.serviceType === 1
          ? 'rgba(118, 185, 0, 0.75)'
          : 'rgba(0, 113, 197, 0.75)'
      }`"
    >
      <img
        :src="`/logo/${
          element.serviceType === 1 ? 'nvidia-wordmark' : 'intel-header-logo'
        }.svg`"
        style="height: 0.75rem"
      />
    </div>
    <div
      class="d-flex flex-fill flex-column mt-1"
      style="justify-content: space-evenly"
    >
      <div
        class="d-flex justify-content-center"
        style="font-size: 0.8rem; width: 8.5rem"
      >
        <img
          :src="`/package/${element.packageId.toLowerCase()}.svg`"
          style="height: 1.65rem"
        />
      </div>
      <div class="d-flex flex-row justify-content-center align-items-center">
        <img
          :src="`/os/${element.operatingSystem}-${element.osVersion}.svg`" 
          :onerror="`this.src='/os/${element.operatingSystem}.svg'`"
          style="width: 0.75rem"
        />
        <div style="color: #757575; font-size: 0.8rem" class="ml-2">
          <span>
            {{ element.operatingSystem === operatingSystem.WINDOWS ? "Windows" : "Ubuntu" }}
          </span>
          <span v-if="element.operatingSystem === operatingSystem.WINDOWS && element.osVersion">
            {{ element.osVersion }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OPERATING_SYSTEM } from "@/constant/rental";

export default {
  data() {
    return {
      operatingSystem: OPERATING_SYSTEM,
    };
  },

  props: {
    element: {
      type: Object,
      default(){
        return {};
      },
    },
  },
};
</script>